import ExpandableRowContainer from './expandable-row-container';

export default ExpandableRowContainer;